import React from 'react';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicExampleCode from '!!raw-loader!./examples/Basic';
import HorizontalExampleCode from '!!raw-loader!./examples/Horizontal';
import MajorUnitExampleCode from '!!raw-loader!./examples/MajorUnit';
import NoLabelsExampleCode from '!!raw-loader!./examples/NoLabels';
import NoValueExampleCode from '!!raw-loader!./examples/NoValue';
import PercentageRangeExampleCode from '!!raw-loader!./examples/PercentageRange';
import PercentageValueExampleCode from '!!raw-loader!./examples/PercentageValue';
import BackgroundColorExampleCode from '!!raw-loader!./examples/BackgroundColor';

import BasicExample from './examples/Basic';
import HorizontalExample from './examples/Horizontal';
import MajorUnitExample from './examples/MajorUnit';
import NoLabelsExample from './examples/NoLabels';
import NoValueExample from './examples/NoValue';
import PercentageRangeExample from './examples/PercentageRange';
import PercentageValueExample from './examples/PercentageValue';
import BackgroundColorExample from './examples/BackgroundColor';

import optionsSchema from '../optionsSchema';
import doc from './definition';

export default () => (
    <VisualizationDocPage
        title="FillerGauge"
        examplesSection={[
            <DocExample
                title="Basic Filler Gauge"
                key="basic"
                description="Filler Gauge takes 100% width and 250px height by default."
                code={BasicExampleCode}
                example={BasicExample}
            />,
            <DocExample
                title="Horizontal Gauge"
                key="horizontal"
                description="Sets the horizontal orientation of the gauge. Defaults to vertical."
                code={HorizontalExampleCode}
                example={HorizontalExample}
            />,
            <DocExample
                title="Мajor Unit is 25"
                key="major_unit"
                description="Specifies, in pixels, the spacing of major tick marks."
                code={MajorUnitExampleCode}
                example={MajorUnitExample}
            />,
            <DocExample
                title="No Labels"
                key="no_labels"
                description="Gauge displays no labels. Defaults to true."
                code={NoLabelsExampleCode}
                example={NoLabelsExample}
            />,
            <DocExample
                title="No Value"
                key="no_value"
                description="Gauge displays no value. Defaults to true."
                code={NoValueExampleCode}
                example={NoValueExample}
            />,
            <DocExample
                title="Percentage Range"
                key="percentage_range"
                description="Gauge displays range as percentages. Defaults to false."
                code={PercentageRangeExampleCode}
                example={PercentageRangeExample}
            />,
            <DocExample
                title="Percentage Value"
                key="percentage_value"
                description="Gauge displays value as percentages. Defaults to false."
                code={PercentageValueExampleCode}
                example={PercentageValueExample}
            />,
            <DocExample
                title="Background Color is blue"
                key="background_color"
                description="The HEX color code for chart background color is blue."
                code={BackgroundColorExampleCode}
                example={BackgroundColorExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
    />
);
